interface StatusBadgeProps {
  status: string;
}

const statusConfig: Record<string, { color: string; bg: string; label: string }> = {
  pending: {
    color: 'text-yellow-800',
    bg: 'bg-yellow-100',
    label: '待处理',
  },
  running: {
    color: 'text-blue-800',
    bg: 'bg-blue-100',
    label: '运行中',
  },
  completed: {
    color: 'text-green-800',
    bg: 'bg-green-100',
    label: '已完成',
  },
  failed: {
    color: 'text-red-800',
    bg: 'bg-red-100',
    label: '失败',
  },
  cancelled: {
    color: 'text-gray-800',
    bg: 'bg-gray-100',
    label: '已取消',
  },
};

function StatusBadge({ status }: StatusBadgeProps) {
  const config = statusConfig[status] || statusConfig.pending;

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.bg} ${config.color}`}
    >
      {config.label}
    </span>
  );
}

export default StatusBadge;
